import type { User } from "@fairfleet/geotab";
import { getUserEmail } from "./getUserEmail";

export type UserNameOrder = "firstLast" | "lastFirst";

/**
 * "First Last" for display; "Last, First" for sortable driver lists; the e-mail only when the user
 * has no name.
 */
export function getUserDisplayName(
  user: User | null | undefined,
  order: UserNameOrder = "firstLast",
): string {
  if (!user) return "";

  const first = user.firstName?.trim() ?? "";
  const last = user.lastName?.trim() ?? "";

  if (first && last) {
    return order === "firstLast" ? `${first} ${last}` : `${last}, ${first}`;
  }

  if (first) return first;
  if (last) return last;

  return getUserEmail(user) ?? "";
}

/**
 * "Name (e-mail)" for fields that are stored and must tell users with the same name apart, such
 * as who marked a report done. Just the e-mail when the user has no name.
 */
export function getUserAuditName(user: User | null | undefined): string {
  if (!user) return "";
  const name = getUserDisplayName(user);
  const email = getUserEmail(user) ?? "";
  return email && name !== email ? `${name} (${email})` : name;
}
